import { render } from "./IntermediateQAView.vue?vue&type=template&id=78737ec7&scoped=true&ts=true"
import script from "./IntermediateQAView.vue?vue&type=script&lang=ts"
export * from "./IntermediateQAView.vue?vue&type=script&lang=ts"

import "./IntermediateQAView.vue?vue&type=style&index=0&id=78737ec7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78737ec7"]])

export default __exports__